import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import InputItem from '../Forms/InputItem/InputItem';
import FormButton from '../Forms/FormButton/FormButton';
import Fader from '../Loaders/Fader';

import { setNotify } from '../../../datastore/actions/actionActions';
import { createGroup, saveGroup } from '../../../http/groupsAPI';
import useOutsideClick from '../../../util/useOutsideClick';

const GroupAdd = ({ isOpen, onSaveHandler, onCloseHandler, groupData, loading }) => {
  const dispatch = useDispatch();

  const [name, setName] = useState('');
  const [saving, setSaving] = useState(false);

  const config = useSelector((state) => state.config.config);

  const windowRef = useRef();

  useEffect(() => {
    if (groupData) {
      setName(groupData.name);
    }
  }, [groupData]);

  const checkIsValid = () => {
    if (name) {
      return true;
    }

    return false;
  };

  const handleSave = async () => {
    if (checkIsValid()) {
      setSaving(true);

      const res = await saveGroup(config, groupData.id, name);

      if (res.status === 200) {
        dispatch(
          setNotify({
            status: true,
            type: 'success',
            title: 'Success',
            message: res.data.message,
          }),
        );
        onSaveHandler();
      } else {
        dispatch(
          setNotify({
            status: true,
            type: 'error',
            title: 'Error',
            message: res.message,
          }),
        );
      }
      setSaving(false);
    } else {
      dispatch(
        setNotify({
          status: true,
          type: 'error',
          title: 'Error',
          message: 'Fill in all the fields',
        }),
      );
    }
  };

  const handleCreate = async () => {
    if (checkIsValid()) {
      setSaving(true);

      const res = await createGroup(config, name);

      if (res.status === 201) {
        dispatch(
          setNotify({
            status: true,
            type: 'success',
            title: 'Success',
            message: res.data.message,
          }),
        );
        onSaveHandler();
      } else {
        dispatch(
          setNotify({
            status: true,
            type: 'error',
            title: 'Error',
            message: res.message,
          }),
        );
      }
      setSaving(false);
    } else {
      dispatch(
        setNotify({
          status: true,
          type: 'error',
          title: 'Error',
          message: 'Fill in all the fields',
        }),
      );
    }
  };

  useOutsideClick(windowRef, null, isOpen, onCloseHandler);

  return (
    <div className="login-wrap user-add-wrap">
      <div className="login-view">
        {!loading ? (
          <div ref={windowRef} className="login-box add-user-box">
            {!saving ? (
              <div className="logo-large">{groupData ? 'Edit Search Group' : 'Create A New Search Group'}</div>
            ) : (
              <>
                <div className="logo-large">{groupData ? 'Saving Group Information' : 'Creating Group'}</div>
                <div className="logo-sub user-space">
                  The process should take no longer than 30 seconds. Please Wait...
                </div>
              </>
            )}
            {!saving ? (
              <>
                <div className="add-user-left">
                  <InputItem
                    label="Name"
                    type={'text'}
                    icon={null}
                    onChange={(e) => setName(e.target.value)}
                    value={name}
                  />
                </div>
                <div className="submit">
                  <FormButton
                    subLink={'Cancel'}
                    subLinkClick={onCloseHandler}
                    text={groupData ? 'Save' : 'Create'}
                    onClick={groupData ? handleSave : handleCreate}
                  />
                </div>
              </>
            ) : (
              <Fader size={50} />
            )}
          </div>
        ) : (
          <div ref={windowRef} className="login-box add-user-box">
            <Fader />
          </div>
        )}
      </div>
    </div>
  );
};

export default GroupAdd;
